export enum PermissionConsts {
    // Pages
    Pages_Users = 'Pages.Users',
    Pages_Roles = 'Pages.Roles',
    Pages_Consultancies = 'Pages.Consultancies',
    Pages_Purchase_History = 'Pages.Purchase.History',
    Pages_Purchase_History_Course = 'Pages.Purchase.History.Course',
    Pages_Purchase_History_Resource = 'Pages.Purchase.History.Resource',
    Pages_Purchase_History_Event = 'Pages.Purchase.History.Event',
    Pages_Users_Activation = 'Pages.Users.Activation',
    Pages_Tennants = 'Pages.Tennants',
    Pages_Course = 'Pages.Course',
    Pages_Checkout = 'Pages.Checkout',

    // User
    User_RequestEmailConfirmation = 'User.RequestEmailConfirmation',
    User_Create = 'User.Create',
    User_Edit = 'User.Edit',
    User_Delete = 'User.Delete',
    User_ForceResetPassword = 'User.ForceResetPassword',
    User_Deactive = 'User.Deactivate',
    User_UnlockLogin = 'User.UnlockLogin',
    User_GenerateCredits = 'User.GenerateCredits',
    User_Dashboard = 'User.Dashboard',
    Company_Dashboard = 'Company.Dashboard',
    User_AssignCourse = 'User.AssignCourse',
    User_AssignResource = 'User.AssignResource',
    User_TransferCredits = 'User.TransferCredits',
    User_BackOffice = 'User.BackOffice',
    User_GetAll = 'User.GetAll',

    // File
    File_Create = 'File.Create',
    File_Edit = 'File.Edit',
    File_Delete = 'File.Delete',
    File_GetAll = 'File.GetAll',
    File_Get = 'File.Get',

    // Course
    Course_Create = 'Course.Create',
    Course_Edit = 'Course.Edit',
    Course_Delete = 'Course.Delete',
    Course_Activate = 'Course.Activate',
    Course_AssociateTeacher = 'Course.AssociateTeacher',

    // Theme
    Theme_Create = 'Theme.Create',
    Theme_Edit = 'Theme.Edit',
    Theme_Delete = 'Theme.Delete',
    Theme_Get = 'Theme.Get',

    // Module
    Module_Create = 'Module.Create',
    Module_Edit = 'Module.Edit',
    Module_Delete = 'Module.Delete',
    Module_Get = 'Module.Get',
    Module_GetAll = 'Module.GetAll',

    // Teacher
    Teacher_Create = 'Teacher.Create',
    Teacher_Edit = 'Teacher.Edit',
    Teacher_Delete = 'Teacher.Delete',

    // Export
    UserCoursePurchase_Export = 'UserCoursePurchase.Export',
    UserResourcePurchase_Export = 'UserResourcePurchase.Export',
    UserEventPurchase_Export = 'UserEventPurchase.Export',
    UserList_Export = 'UserList.Export',

    // Lesson
    Lesson_Create = 'Lesson.Create',
    Lesson_Edit = 'Lesson.Edit',
    Lesson_Delete = 'Lesson.Delete',
    Lesson_Get = 'Lesson.Get',
    Lesson_GetAll = 'Lesson.GetAll',
    Lesson_Watch = 'Lesson.Watch',

    // Slider
    Slider_Create = 'Slider.Create',
    Slider_Edit = 'Slider.Edit',
    Slider_Delete = 'Slider.Delete',

    // Credit pack
    CreditPack_Skip = 'CreditPack.Skip',

    // Wizard
    Wizard_Create = 'Wizard.Create',

    //Discount Code
    DiscountCode_Create = 'DiscountCode.Create',
    DiscountCode_Edit = 'DiscountCode.Edit',
    DiscountCode_Delete = 'DiscountCode.Delete',
    DiscountCode_Get = 'DiscountCode.Get',
    DiscountCode_GetAll = 'DiscountCode.GetAll',

    // User Lesson
    UserLesson_Create = 'UserLesson.Create',
    UserLesson_Edit = 'UserLesson.Edit',
    UserLesson_Delete = 'UserLesson.Delete',
    UserLesson_Get = 'UserLesson.Get',
    UserLesson_GetAll = 'UserLesson.GetAll',

    // Consultancy
    Consultancy_Create = 'Consultancy.Create',
    Consultancy_Update = 'Consultancy.Update',
    Consultancy_Delete = 'Consultancy.Delete',
    Consultancy_Get = 'Consultancy.Get',
    Consultancy_GetAll = 'Consultancy.GetAll',

    // Event
    Event_Create = 'Event.Create',
    Event_Edit = 'Event.Edit',
    Event_Delete = 'Event.Delete',
    Event_Get = 'Event.Get',
    Event_GetAll = 'Event.GetAll',
    Event_Share = 'Event.Share',

    // Team Member
    TeamMember_Create = 'TeamMember.Create',
    TeamMember_Edit = 'TeamMember.Edit',
    TeamMember_Delete = 'TeamMember.Delete',
    TeamMember_Get = 'TeamMember.Get',
    TeamMember_GetAll = 'TeamMember.GetAll',

    // Contact Team Member
    ContactTeamMember_Create = 'ContactTeamMember.Create',
    ContactTeamMember_Edit = 'ContactTeamMember.Edit',
    ContactTeamMember_Delete = 'ContactTeamMember.Delete',
    ContactTeamMember_Get = 'ContactTeamMember.Get',
    ContactTeamMember_GetAll = 'ContactTeamMember.GetAll',

    // User Questionnaire
    UserQuestionnarie_TestResult = 'CUserQuestionnarie.TestResult',

    // Course Questionnaire
    CourseQuestionnarie_TakeTest = 'CourseQuestionnarie.TakeTest',

    // Resource
    Resource_Create = 'Resource.Create',
    Resource_Edit = 'Resource.Edit',
    Resource_Delete = 'Resource.Delete',
    Resource_Get = 'Resource.Get',
    Resource_GetAll = 'Resource.GetAll',

    // Purchase
    Can_Purchase = 'Can.Purchase',
    Can_Purchase_Multiple = 'Can.Purchase.Multiple',
}
